<template>
  <!-- <div class="svg-icon" :style="customStyle"> -->
  <svg class="svg-icon" v-if="name"  aria-hidden="true" :style="customStyle">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    size: {
      type: [Number, String],
      default: null,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    customStyle() {
      const style = {};

      if (this.color && this.color.length > 0) {
        style['--color'] = this.color;
      }

      if (this.size) {
        style.width = `${this.size}px`;
        style.height = `${this.size}px`;
      } else {
        if (this.width) {
          style.width = isNaN(this.width) ? this.width : `${this.width}px`;
        }
        if (this.height) {
          style.height = isNaN(this.height) ? this.height : `${this.height}px`;
        }
      }

      return style;
    },
  },
};
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  overflow: hidden;
  fill: currentColor;
  vertical-align: middle;
  color: var(--color);
}

/* .svg-icon svg {
  width: 100%;
  height: 100%;
} */
</style>
